import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import ActionButton from '@/components/Button/ActionButton';
import { HStack, VStack } from '@/components/Layout';
import { ProductLogoMediumLaborCore as LogoLaborCore } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { StartOperationTaskDialog } from './_packages/-components/StartOperationTaskDialog';
export const Route = createFileRoute('/_staff/labor-core/_packages')({
  component: LaborCoreLayout
});
function LaborCoreLayout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.laborCore.operationPackages'
  });
  useDocumentTitle(t('laborCore'));
  const [startTaskDialogOpen, setStartTaskDialogOpen] = useState(false);
  const handleCloseDialog = () => {
    setStartTaskDialogOpen(false);
  };
  const handleOpenDialog = () => {
    setStartTaskDialogOpen(true);
  };
  const isSettingsEnabled = featureFlags.check('GOVERNMENT_APPLICATION');
  const tabs: TabWithIndicatorProps[] = useMemo(() => {
    const baseTabs: TabWithIndicatorProps[] = [{
      to: '/labor-core',
      children: t('tabs.operationPackages'),
      activeOptions: {
        exact: true,
        includeSearch: true
      }
    }, {
      to: '/labor-core/archives',
      children: t('tabs.archive'),
      activeOptions: {
        exact: true
      }
    }, {
      to: '/labor-core/configs',
      children: t('tabs.config'),
      activeOptions: {
        exact: true
      }
    }];
    if (isSettingsEnabled) {
      baseTabs.push({
        to: '/labor-core/settings',
        hash: 'applicant-contacts',
        children: t('tabs.settings'),
        activeOptions: {
          exact: false
        }
      });
    }
    return baseTabs;
  }, [t, isSettingsEnabled]);
  return <VStack>
      <ProductHeader Logo={LogoLaborCore} name={t('laborCore')} tabs={tabs} type="core">
        <HStack className="ml-auto items-center gap-2 pr-2">
          <ActionButton variant="outline" icon="PlusIcon" iconColor="primary" onClick={handleOpenDialog}>
            {t('startNew')}
          </ActionButton>
        </HStack>
      </ProductHeader>
      <Outlet />
      <StartOperationTaskDialog isOpen={startTaskDialogOpen} onClose={handleCloseDialog} />
    </VStack>;
}